import { useEffect, useState } from "react";

import { ContactFacetType } from "@/Common/Models/Individuals/Enums/ContactFacetType";
import { PatientTab } from "@/Patient/Components/PatientTab";
import { RelativeTab } from "@/Relative/Components/RelativeTab";

function PersonTab(): JSX.Element {
    const [currentPerson, setCurrentPerson] = useState(sessionStore.selectedFile);

    function sessionStoreChanged(): void {
        if (sessionStore.selectedFile !== currentPerson) {
            setCurrentPerson(sessionStore.selectedFile);
        }
    }

    const sessionStoreListenerRef = sessionStore.AddChangeListener(sessionStoreChanged, this);

    useEffect(() => () => {
        sessionStore.RemoveListener(sessionStoreListenerRef);
    }, [sessionStoreListenerRef]);

    if (!currentPerson) {
        // in case a session store event fire before a redirection happen.
        return null;
    }

    return (
        <div className="sub-container">
            <div className="left-nav-menu closed transition">
                <div className="ws-scrollable hide-overflow" />
            </div>
            <div className="workspace">
                {currentPerson.ContactFacetType === ContactFacetType.Relative && <RelativeTab />}
                {currentPerson.ContactFacetType === ContactFacetType.Patient && <PatientTab ActivePatientContactId={currentPerson.ContactId} />}
            </div>
        </div>
    );
}

export { PersonTab };
